module.exports = __webpack_public_path__ + "img/order1.png";